<template>
  <div class="formgrid grid">
    <InputMaskLabel
      id="endereco-cep"
      mask="99999-999"
      label="CEP"
      v-model="v$.endereco.Cep.$model"
      classDiv="col-12 md:col-3"
      :temErro="v$.endereco.Cep.$invalid"
    />
    <InputTextLabel
      id="endereco-logradouro"
      v-model="v$.endereco.Logradouro.$model"
      label="Logradouro"
      classDiv="col-12 md:col-6"
      :temErro="v$.endereco.Logradouro.$invalid"
      :tamanhoMaximo="102"
    />
    <InputTextLabel
      id="endereco-numero"
      v-model="v$.endereco.Numero.$model"
      label="Número"
      classDiv="col-12 md:col-3"
      :temErro="v$.endereco.Numero.$invalid"
      :tamanhoMaximo="10"
    />
    <InputTextLabel
      id="endereco-complemento"
      v-model="endereco.Complemento"
      label="Complemento"
      classDiv="col-12 md:col-6"
      :tamanhoMaximo="200"
    />
    <InputTextLabel
      id="endereco-barrio"
      v-model="v$.endereco.Bairro.$model"
      label="Bairro"
      classDiv="col-12 md:col-6"
      :temErro="v$.endereco.Bairro.$invalid"
      :tamanhoMaximo="32"
    />
    <InputTextLabel
      id="endereco-cidade"
      v-model="v$.endereco.Cidade.$model"
      label="Cidade"
      classDiv="col-12 md:col-6"
      :temErro="v$.endereco.Cidade.$invalid"
      :tamanhoMaximo="32"
    />
    <DropDownLabel
      id="endereco-estado"
      v-model="v$.endereco.Estado.$model"
      :modelValue="v$.endereco.Estado.$model"
      :options="listaEstado"
      optionValue="codigo"
      placeholder="Selecione"
      label="Estado"
      classDiv="col-12 md:col-6"
      :temErro="v$.endereco.Estado.$invalid"
    />
  </div>
</template>

<script>
import InputMaskLabel from "@/components/comuns/InputMaskLabel.vue";
import InputTextLabel from "@/components/comuns/InputTextLabel.vue";
import DropDownLabel from "@/components/comuns/DropDownLabel.vue";
import { pesquisarCep } from "@/services/ServicoExterno/cepService";
import { useVuelidate } from "@vuelidate/core";
import { requiredIf } from "@vuelidate/validators";

export default {
  name: "EnderecoComponent",

  emits: ["update:modelValue"],

  setup() {
    return {
      v$: useVuelidate(),
    };
  },

  props: {
    submitted: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Object,
      default: () => {
        return {
          Cep: "",
          Logradouro: "",
          Numero: "",
          Complemento: "",
          Bairro: "",
          Cidade: "",
          Estado: "",
        };
      },
    },
    camposObrigatorios: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    InputMaskLabel,
    InputTextLabel,
    DropDownLabel,
  },

  data() {
    return {
      obrigatorios: false,
      endereco: this.modelValue,
      listaEstado: [
        { descricao: "", codigo: "" },
        { descricao: "AC", codigo: "AC" },
        { descricao: "AL", codigo: "AL" },
        { descricao: "AP", codigo: "AP" },
        { descricao: "AM", codigo: "AM" },
        { descricao: "BA", codigo: "BA" },
        { descricao: "CE", codigo: "CE" },
        { descricao: "DF", codigo: "DF" },
        { descricao: "ES", codigo: "ES" },
        { descricao: "GO", codigo: "GO" },
        { descricao: "MA", codigo: "MA" },
        { descricao: "MT", codigo: "MT" },
        { descricao: "MS", codigo: "MS" },
        { descricao: "MG", codigo: "MG" },
        { descricao: "PA", codigo: "PA" },
        { descricao: "PB", codigo: "PB" },
        { descricao: "PR", codigo: "PR" },
        { descricao: "PE", codigo: "PE" },
        { descricao: "PI", codigo: "PI" },
        { descricao: "RJ", codigo: "RJ" },
        { descricao: "RN", codigo: "RN" },
        { descricao: "RS", codigo: "RS" },
        { descricao: "RO", codigo: "RO" },
        { descricao: "RR", codigo: "RR" },
        { descricao: "SC", codigo: "SC" },
        { descricao: "SP", codigo: "SP" },
        { descricao: "SE", codigo: "SE" },
        { descricao: "TO", codigo: "TO" },
      ],
    };
  },

  methods: {
    async atualizaEndereco(cep) {
      cep = cep.replace("_", "").replace("-", "");
      
      if (cep.length < 8) return;

      try {
          await pesquisarCep(cep).then((e) => {
            if (e.data[0] != null) {              
              this.endereco.Logradouro = e.data[0].TipoLogradouro + " " + e.data[0].Logradouro;
              this.endereco.Bairro = e.data[0].Bairro;
              this.endereco.Cidade = e.data[0].Municipio;
              this.endereco.Estado = e.data[0].Uf;
              this.endereco.Complemento = e.data[0].Complemento;
            }
          });
      } catch(err) {
          console.log(err)
      }
    },
    
    EnderecoObrigatorios() {
      return (
        (this.camposObrigatorios ||
        this.endereco.Cep.length > 0 ||
        this.endereco.Logradouro.length > 0 ||
        this.endereco.Numero.length > 0 ||
        this.endereco.Bairro.length > 0 ||
        this.endereco.Cidade.length > 0 ||
        this.endereco.Estado.length > 0) && this.submitted
      );
    },
  },

  validations() {
    return {
      endereco: {
        Cep: {
          requiredIf : requiredIf(() => this.EnderecoObrigatorios())
        },
        Logradouro: {
          requiredIf : requiredIf(() => this.EnderecoObrigatorios())
        },
        Numero: {
          requiredIf : requiredIf(() => this.EnderecoObrigatorios())
        },
        Bairro: {
          requiredIf : requiredIf(() => this.EnderecoObrigatorios())
        },
        Cidade: {
          requiredIf : requiredIf(() => this.EnderecoObrigatorios())
        },
        Estado: {
          requiredIf : requiredIf(() => this.EnderecoObrigatorios())
        },
      },
    };
  },

  watch: {
    "endereco.Cep": function (valorNovo) {
      this.atualizaEndereco(valorNovo);
    },

    endereco: function (valorNovo) {
      this.$emit("update:modelValue", valorNovo);
    },

    submitted: function (valorNovo) {
      console.log(valorNovo);
    }
  },
};
</script>